import {Component, Input} from "@angular/core";

/**
 * A component that renders an SVG icon for "Camera Lock"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-camera-off-outline',
    templateUrl: './icon-camera-off-outline.component.html',
    styleUrls: ['./icon-camera-off-outline.component.scss'],
    standalone: false
})
export class IconCameraOffOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
